import { getAccessToken } from '../authentication/supabaseService';

export interface RecipeNote {
  id: string;
  recipeId: string;
  componentId: string;
  userId: string;
  restaurantId: string;
  content: string;
  createdAt: Date;
}

export interface CreateNoteRequest {
  recipeId: string;
  componentId: string;
  content: string;
  restaurantId: string;
}

export async function fetchNotesByRecipeId(recipeId: string): Promise<RecipeNote[]> {
  const token = await getAccessToken();
  const res = await fetch(`/api/recipe-notes/recipe/${recipeId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    throw new Error(`Failed to fetch recipe notes: ${res.status} ${res.statusText}`);
  }
  const data = await res.json();
  return data.map((item: any) => ({
    ...item,
    createdAt: new Date(item.createdAt),
  }));
}

export async function createRecipeNote(request: CreateNoteRequest): Promise<RecipeNote> {
  const token = await getAccessToken();
  const res = await fetch('/api/recipe-notes/create', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(request),
  });
  if (!res.ok) {
    throw new Error(`Failed to create recipe note: ${res.status} ${res.statusText}`);
  }
  const data = await res.json();
  return {
    ...data,
    createdAt: new Date(data.createdAt),
  };
}

export async function deleteRecipeNote(noteId: string): Promise<void> {
  const token = await getAccessToken();
  const res = await fetch(`/api/recipe-notes/${noteId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  if (!res.ok) {
    throw new Error(`Failed to delete recipe note: ${res.status} ${res.statusText}`);
  }
}
